// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"b8046303","366":"0a985747","787":"c82167e7","998":"39f8e01f"}[chunkId] + ".chunk.js";
};